import React, { Component } from 'react';
import { Modal } from 'antd';
import { connect } from 'react-redux';

import ConfirmForm from './ConfirmForm';
import { checkPassword } from '../../../../actions';

class ConfirmModal extends Component {
  state = {
    fields: {
      password: {
        value: '',
      },
    },
  };

  handleFormChange = (changedFields) => {
    this.setState(({ fields }) => ({
      fields: { ...fields, ...changedFields },
    }));
  }

  checkPassword = async () => {
    let result = false;
    await this.props.checkPassword({
      data: {
        lecturerId: this.props.lecturerId,
        password: this.state.fields.password.value,
      },
      response: {
        success: async () => { result = true; },
        failure: async () => { result = false; },
      },
    });
    return result;
  };

  // checkCaptcha = async () => true;
  
  handleConfirm = async () => {
    /* if (!await this.checkCaptcha()) {
      Modal.error({
        title: 'Sai mã xác thực',
      });
    } else */ if (!await this.checkPassword()) {
      Modal.error({
        title: 'Sai mật khẩu',
      });
    } else {
      this.props.handleConfirm();
    }
  }

  render() {
    const { fields } = this.state;
    return (
      <Modal
        title="Xác nhận thay đổi"
        visible
        onOk={this.handleConfirm}
        onCancel={this.props.handleClose}
      >
        <ConfirmForm 
          {...fields}
          onChange={this.handleFormChange}
          formItemLayout={this.props.formItemLayout}
          tailFormItemLayout={this.props.tailFormItemLayout} 
        />
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  lecturerId: state.user.info.lecturerId,
});

const mapDispatchToProps = {
  checkPassword,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmModal);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Modals/ConfirmModal/ConfirmModal.js